import { MenuItemProps, useTranslationLang, useTranslationRoute, useTranslations } from "@harea/component";
import { CalendarOff, CalendarX2, CalendarClock, Baby } from "lucide-react";
import { useMemo } from "react";

export const useLeftSideBarMenuAbsences = () => {

    const [
        ABSENCE,
        DEMANDES,
        MISSINGS,
        RETARD,
    ] = useTranslations(i18n)

    const { lang } = useTranslationLang()
    const translationRoute = useTranslationRoute();

    return useMemo((): MenuItemProps => ({
        ke: "absences",
        label: ABSENCE,
        className: "menu-item-category",
        items: [
            {
                label: DEMANDES,
                startIcon: <CalendarOff />,
                link: translationRoute("admin/timeoffs/demands"),
            },
            {
                label: MISSINGS,
                startIcon: <CalendarX2 />,
                link: translationRoute("admin/timeoffs/missings"),
            },
            {
                label: RETARD,
                startIcon: <CalendarClock />,
                link: translationRoute("admin/timeoffs/lates"),
            },
        ],
    }), [lang])
}

const i18n = [
    'Harea.Admin.LeftSideBar.Menu.General.Absence.Label',
    'BSMRH.Admin.LeftSideBar.Menu.General.Absence.Demande.Label',
    'BSMRH.Project.DayOff.Management.Vacation.Abscence.Label',
    'std_late',
]

